import React from "react";

import classNames from "classnames";

interface Props extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

const Globe: React.FC<Props> = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36.499"
      height="33.193"
      viewBox="0 0 36.499 33.193"
      className={classNames([className!])}
      {...props}
    >
      <g
        id="Group_131"
        data-name="Group 131"
        transform="translate(-1530.339 -428.312)"
        fill="currentColor"
      >
        <g id="world-globe-line-icon" transform="translate(1530.339 428.312)">
          <path
            id="Path_31"
            data-name="Path 31"
            d="M27.061,22.126a.684.684,0,0,1,.132.013,15.243,15.243,0,0,0,.775-1.554c0-.011.009-.021.015-.032a13.248,13.248,0,0,0,.793-2.576,13.986,13.986,0,0,0,.256-2.124H24.856a13.511,13.511,0,0,1-1.888,6.272h4.094Zm-.728,1.331H22.127a28.132,28.132,0,0,1-5.151,5.48q.507-.063,1-.162a13.2,13.2,0,0,0,2.608-.807h0a14.636,14.636,0,0,0,2.375-1.285A13.428,13.428,0,0,0,25,25l0,0h0a13.426,13.426,0,0,0,1.33-1.543ZM13.4,28.938a28.139,28.139,0,0,1-5.151-5.48H4.045A13.445,13.445,0,0,0,5.374,25l0,0h0a13.452,13.452,0,0,0,2.04,1.68,14.615,14.615,0,0,0,2.375,1.285l.032.015a13.228,13.228,0,0,0,2.576.793q.5.1,1,.162ZM3.177,22.126H7.41a13.508,13.508,0,0,1-1.888-6.272H1.346A13.951,13.951,0,0,0,1.6,17.978a13.22,13.22,0,0,0,.807,2.608h0a15.11,15.11,0,0,0,.768,1.541Zm-1.831-7.6h4.2A14.481,14.481,0,0,1,7.626,8.251H3.177A15.09,15.09,0,0,0,2.41,9.792L2.4,9.824A13.239,13.239,0,0,0,1.6,12.4a13.955,13.955,0,0,0-.256,2.124Zm2.7-7.6H8.479A31.172,31.172,0,0,1,13.5,1.429q-.555.065-1.1.173a13.215,13.215,0,0,0-2.608.807h0A14.616,14.616,0,0,0,7.417,3.695a13.466,13.466,0,0,0-2.04,1.68l0,0h0A13.448,13.448,0,0,0,4.045,6.92ZM16.882,1.428A31.184,31.184,0,0,1,21.9,6.92h4.435A13.425,13.425,0,0,0,25,5.377l0,0h0a13.427,13.427,0,0,0-2.04-1.68,14.637,14.637,0,0,0-2.375-1.286l-.031-.015A13.238,13.238,0,0,0,17.978,1.6q-.541-.108-1.1-.173ZM27.2,8.251H22.751a14.478,14.478,0,0,1,2.079,6.272h4.2a14.014,14.014,0,0,0-.256-2.124,13.236,13.236,0,0,0-.807-2.608h0A15.04,15.04,0,0,0,27.2,8.251ZM12.14.3a15.843,15.843,0,0,1,6.1,0,14.557,14.557,0,0,1,2.836.877l.037.014A15.919,15.919,0,0,1,23.7,2.593a15.024,15.024,0,0,1,4.086,4.086A15.951,15.951,0,0,1,29.19,9.267h0v0a14.523,14.523,0,0,1,.891,2.87,15.859,15.859,0,0,1,0,6.1,14.56,14.56,0,0,1-.877,2.836c0,.012-.009.024-.015.036A15.93,15.93,0,0,1,27.785,23.7,15.024,15.024,0,0,1,23.7,27.785,15.908,15.908,0,0,1,21.11,29.19h0a14.544,14.544,0,0,1-2.87.891,15.843,15.843,0,0,1-6.1,0A14.569,14.569,0,0,1,9.3,29.2l-.036-.015a15.892,15.892,0,0,1-2.589-1.405A15.028,15.028,0,0,1,2.592,23.7,15.919,15.919,0,0,1,1.187,21.11h0v0A14.539,14.539,0,0,1,.3,18.238a15.838,15.838,0,0,1,0-6.1A14.561,14.561,0,0,1,1.173,9.3c0-.012.009-.024.014-.036A15.913,15.913,0,0,1,2.593,6.678,15.028,15.028,0,0,1,6.678,2.592,15.94,15.94,0,0,1,9.267,1.187h0A14.6,14.6,0,0,1,12.14.3Zm3.715,2V6.92h4.407a31.7,31.7,0,0,0-4.407-4.629Zm0,5.96v6.272H23.5a13.705,13.705,0,0,0-2.3-6.272Zm0,7.6v6.272h5.565a12.592,12.592,0,0,0,2.109-6.272Zm0,7.6v4.685a28.726,28.726,0,0,0,4.634-4.685Zm-1.331,4.686V23.458H9.889a28.71,28.71,0,0,0,4.635,4.686Zm0-6.017V15.854H6.849a12.584,12.584,0,0,0,2.109,6.272h5.565Zm0-7.6V8.251H9.182a13.71,13.71,0,0,0-2.3,6.272Zm0-7.6V2.291A31.7,31.7,0,0,0,10.116,6.92Z"
            transform="translate(0 0)"
          />
        </g>
        <ellipse
          id="Ellipse_24"
          data-name="Ellipse 24"
          cx="11.911"
          cy="11.911"
          rx="11.911"
          ry="11.911"
          transform="translate(1543.016 437.682)"
          fill="currentColor"
        />
        <g
          id="Group_115"
          data-name="Group 115"
          transform="translate(1545.117 441.186)"
        >
          <path
            id="Path_1"
            data-name="Path 1"
            d="M765.169,375.583a9.9,9.9,0,0,0-4.753-8.463l-.835,1.451a8.23,8.23,0,0,1,0,14.021l.835,1.452a9.9,9.9,0,0,0,4.753-8.461Z"
            transform="translate(-745.356 -367.12)"
            fill="#fff"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M641.985,375.583a8.23,8.23,0,0,1,3.916-7.011l-.835-1.452a9.91,9.91,0,0,0,0,16.924l.835-1.451A8.23,8.23,0,0,1,641.985,375.583Z"
            transform="translate(-640.314 -367.121)"
            fill="#fff"
          />
          <path
            id="Path_3"
            data-name="Path 3"
            d="M668.709,396.315a5.388,5.388,0,0,1,2.5-4.549l-.638-1.106a6.667,6.667,0,0,0,0,11.308l.638-1.106A5.387,5.387,0,0,1,668.709,396.315Z"
            transform="translate(-664.199 -387.853)"
            fill="#fff"
          />
          <path
            id="Path_4"
            data-name="Path 4"
            d="M750.134,396.315a5.389,5.389,0,0,1-2.5,4.548l.639,1.105a6.667,6.667,0,0,0,0-11.308l-.638,1.106A5.389,5.389,0,0,1,750.134,396.315Z"
            transform="translate(-734.835 -387.853)"
            fill="#fff"
          />
          <path
            id="Path_5"
            data-name="Path 5"
            d="M741.4,412.467A4.144,4.144,0,0,0,739.523,409l-.393.681a3.366,3.366,0,0,1,0,5.581l.392.681a4.143,4.143,0,0,0,1.875-3.473Z"
            transform="translate(-727.344 -404.005)"
            fill="#fff"
          />
          <path
            id="Path_6"
            data-name="Path 6"
            d="M688.56,412.441a4.144,4.144,0,0,0,1.876,3.47l.393-.681a3.366,3.366,0,0,1,0-5.581l-.393-.68a4.145,4.145,0,0,0-1.875,3.471Z"
            transform="translate(-682.806 -403.979)"
            fill="#fff"
          />
          <path
            id="Path_7"
            data-name="Path 7"
            d="M733.393,423.477a1.828,1.828,0,0,1-.723,1.456l.3.519a2.426,2.426,0,0,0,0-3.951l-.3.52a1.827,1.827,0,0,1,.723,1.456Z"
            transform="translate(-721.655 -415.015)"
            fill="#fff"
          />
          <path
            id="Path_8"
            data-name="Path 8"
            d="M703.546,423.476a1.83,1.83,0,0,1,.716-1.456l-.3-.52a2.426,2.426,0,0,0,0,3.951l.3-.519A1.831,1.831,0,0,1,703.546,423.476Z"
            transform="translate(-695.473 -415.014)"
            fill="#fff"
          />
          <circle
            id="Ellipse_16"
            data-name="Ellipse 16"
            cx="0.584"
            cy="0.584"
            r="0.584"
            transform="translate(9.319 7.878)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

export default Globe;
